import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.nu;

export const nu = {
  slug: "nu",
  name: "Northwestern University",
  colors: {
    primary1: "#fff",
    text: "#000",
  },
  fonts: {
    base: "Akkurat Pro, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/5892510e-1087-4c48-acf7-8f6bc4001ce3/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
  programConfigs,
};

